/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface PaymentProvidersService {
  /** @summary Get Payment Providers */
  getPaymentProvidersPaymentProvidersGet: {
    /** @summary Get Payment Providers */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetPaymentProvidersPaymentProvidersGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetPaymentProvidersPaymentProvidersGetSchema,
        options: {
          parameters: GetPaymentProvidersPaymentProvidersGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError>
      >
    ): Promise<
      RequestFnResponse<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError>
    >;
    /** @summary Get Payment Providers */
    getQueryKey(
      parameters: DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void
    ): ServiceOperationQueryKey<
      GetPaymentProvidersPaymentProvidersGetSchema,
      GetPaymentProvidersPaymentProvidersGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useQuery()
     * ```
     */
    useQuery<TData = GetPaymentProvidersPaymentProvidersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError,
          TData,
          ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetPaymentProvidersPaymentProvidersGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useQuery()
     * ```
     */
    useQuery<TData = GetPaymentProvidersPaymentProvidersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError,
          TData,
          ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetPaymentProvidersPaymentProvidersGetError>>;
    /** @summary Get Payment Providers */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetPaymentProvidersPaymentProvidersGetSchema,
      GetPaymentProvidersPaymentProvidersGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters,
      TQueryFnData = GetPaymentProvidersPaymentProvidersGetData,
      TData = OperationInfiniteData<TQueryFnData, GetPaymentProvidersPaymentProvidersGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetPaymentProvidersPaymentProvidersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetPaymentProvidersPaymentProvidersGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters,
      TQueryFnData = GetPaymentProvidersPaymentProvidersGetData,
      TData = OperationInfiniteData<TQueryFnData, GetPaymentProvidersPaymentProvidersGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetPaymentProvidersPaymentProvidersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetPaymentProvidersPaymentProvidersGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getPaymentProvidersPaymentProvidersGetTotal = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getPaymentProvidersPaymentProvidersGetResults = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getPaymentProvidersPaymentProvidersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getPaymentProvidersPaymentProvidersGetCombinedResults = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getPaymentProvidersPaymentProvidersGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetPaymentProvidersPaymentProvidersGetSchema,
          GetPaymentProvidersPaymentProvidersGetParameters,
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetPaymentProvidersPaymentProvidersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError,
          TData,
          ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetPaymentProvidersPaymentProvidersGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters,
      TData = GetPaymentProvidersPaymentProvidersGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError,
          OperationInfiniteData<TData, GetPaymentProvidersPaymentProvidersGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetPaymentProvidersPaymentProvidersGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetPaymentProvidersPaymentProvidersGetParameters>,
      OperationError<GetPaymentProvidersPaymentProvidersGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Payment Providers
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getPaymentProvidersPaymentProvidersGetData = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getPaymentProvidersPaymentProvidersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getPaymentProvidersPaymentProvidersGetCombinedData = qraft.paymentProvidersService.getPaymentProvidersPaymentProvidersGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getPaymentProvidersPaymentProvidersGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetPaymentProvidersPaymentProvidersGetSchema,
          GetPaymentProvidersPaymentProvidersGetParameters,
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetPaymentProvidersPaymentProvidersGetData,
              GetPaymentProvidersPaymentProvidersGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Payment Providers */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<GetPaymentProvidersPaymentProvidersGetData>;
    /** @summary Get Payment Providers */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<void>;
    /** @summary Get Payment Providers */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<GetPaymentProvidersPaymentProvidersGetData>;
    /** @summary Get Payment Providers */
    fetchInfiniteQuery<TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        DeepReadonly<TPageParam>,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters
      >
    >;
    /** @summary Get Payment Providers */
    prefetchInfiniteQuery<TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        DeepReadonly<TPageParam>,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<void>;
    /** @summary Get Payment Providers */
    ensureInfiniteQueryData<TPageParam extends GetPaymentProvidersPaymentProvidersGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters,
        DeepReadonly<TPageParam>,
        GetPaymentProvidersPaymentProvidersGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        GetPaymentProvidersPaymentProvidersGetData,
        GetPaymentProvidersPaymentProvidersGetParameters
      >
    >;
    /** @summary Get Payment Providers */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void)
    ): GetPaymentProvidersPaymentProvidersGetData | undefined;
    /** @summary Get Payment Providers */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void)
    ):
      | OperationInfiniteData<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetParameters
        >
      | undefined;
    /** @summary Get Payment Providers */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetPaymentProvidersPaymentProvidersGetSchema,
              GetPaymentProvidersPaymentProvidersGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetPaymentProvidersPaymentProvidersGetData,
                    GetPaymentProvidersPaymentProvidersGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetPaymentProvidersPaymentProvidersGetSchema,
              GetPaymentProvidersPaymentProvidersGetParameters
            >,
            data: GetPaymentProvidersPaymentProvidersGetData | undefined,
          ]
        >;
    /** @summary Get Payment Providers */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | void)
    ): QueryState<GetPaymentProvidersPaymentProvidersGetData, GetPaymentProvidersPaymentProvidersGetError> | undefined;
    /** @summary Get Payment Providers */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            GetPaymentProvidersPaymentProvidersGetData,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
          GetPaymentProvidersPaymentProvidersGetError
        >
      | undefined;
    /** @summary Get Payment Providers */
    setQueryData(
      parameters:
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | undefined)
        | ServiceOperationQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
      updater: Updater<
        NoInfer<GetPaymentProvidersPaymentProvidersGetData> | undefined,
        NoInfer<DeepReadonly<GetPaymentProvidersPaymentProvidersGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetPaymentProvidersPaymentProvidersGetData | undefined;
    /** @summary Get Payment Providers */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetPaymentProvidersPaymentProvidersGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetPaymentProvidersPaymentProvidersGetData,
              GetPaymentProvidersPaymentProvidersGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetPaymentProvidersPaymentProvidersGetData,
                GetPaymentProvidersPaymentProvidersGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetPaymentProvidersPaymentProvidersGetData,
          GetPaymentProvidersPaymentProvidersGetParameters
        >
      | undefined;
    /** @summary Get Payment Providers */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >,
      updater: Updater<
        NoInfer<GetPaymentProvidersPaymentProvidersGetData> | undefined,
        NoInfer<GetPaymentProvidersPaymentProvidersGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetPaymentProvidersPaymentProvidersGetData | undefined>;
    /** @summary Get Payment Providers */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetPaymentProvidersPaymentProvidersGetSchema,
        GetPaymentProvidersPaymentProvidersGetData,
        TInfinite,
        GetPaymentProvidersPaymentProvidersGetParameters,
        GetPaymentProvidersPaymentProvidersGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Payment Providers */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Payment Providers */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Payment Providers */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
    ): void;
    /** @summary Get Payment Providers */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Payment Providers */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
        | QueryFiltersByQueryKey<
            GetPaymentProvidersPaymentProvidersGetSchema,
            GetPaymentProvidersPaymentProvidersGetData,
            TInfinite,
            GetPaymentProvidersPaymentProvidersGetParameters,
            GetPaymentProvidersPaymentProvidersGetError
          >
    ): number;
    schema: GetPaymentProvidersPaymentProvidersGetSchema;
    types: {
      parameters: GetPaymentProvidersPaymentProvidersGetParameters;
      data: GetPaymentProvidersPaymentProvidersGetData;
      error: GetPaymentProvidersPaymentProvidersGetError;
    };
  };
  /** @summary Setup Payment Provider */
  setupPaymentProviderPaymentProvidersSetupPost: {
    /** @summary Setup Payment Provider */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SetupPaymentProviderPaymentProvidersSetupPostBody,
        SetupPaymentProviderPaymentProvidersSetupPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SetupPaymentProviderPaymentProvidersSetupPostSchema,
        options: ServiceOperationMutationFnOptions<
          SetupPaymentProviderPaymentProvidersSetupPostBody,
          SetupPaymentProviderPaymentProvidersSetupPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SetupPaymentProviderPaymentProvidersSetupPostData,
          SetupPaymentProviderPaymentProvidersSetupPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        SetupPaymentProviderPaymentProvidersSetupPostData,
        SetupPaymentProviderPaymentProvidersSetupPostError
      >
    >;
    /** @summary Setup Payment Provider */
    getMutationKey(
      parameters: DeepReadonly<SetupPaymentProviderPaymentProvidersSetupPostParameters> | void
    ): ServiceOperationMutationKey<
      SetupPaymentProviderPaymentProvidersSetupPostSchema,
      SetupPaymentProviderPaymentProvidersSetupPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup Payment Provider
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SetupPaymentProviderPaymentProvidersSetupPostBody, TContext = unknown>(
      parameters: DeepReadonly<SetupPaymentProviderPaymentProvidersSetupPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SetupPaymentProviderPaymentProvidersSetupPostSchema,
        SetupPaymentProviderPaymentProvidersSetupPostData,
        SetupPaymentProviderPaymentProvidersSetupPostParameters,
        TVariables,
        OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
        TContext
      >
    ): UseMutationResult<
      SetupPaymentProviderPaymentProvidersSetupPostData,
      OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup Payment Provider
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SetupPaymentProviderPaymentProvidersSetupPostBody,
        SetupPaymentProviderPaymentProvidersSetupPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SetupPaymentProviderPaymentProvidersSetupPostSchema,
        SetupPaymentProviderPaymentProvidersSetupPostData,
        SetupPaymentProviderPaymentProvidersSetupPostParameters,
        TVariables,
        OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
        TContext
      >
    ): UseMutationResult<
      SetupPaymentProviderPaymentProvidersSetupPostData,
      OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Setup Payment Provider
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const setupPaymentProviderPaymentProvidersSetupPostTotal = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const setupPaymentProviderPaymentProvidersSetupPostTotal = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupPaymentProviderPaymentProvidersSetupPostSchema,
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Setup Payment Provider
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const setupPaymentProviderPaymentProvidersSetupPostPendingMutationVariables = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const setupPaymentProviderPaymentProvidersSetupPostMutationData = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SetupPaymentProviderPaymentProvidersSetupPostData,
        OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
        MutationVariables<
          SetupPaymentProviderPaymentProvidersSetupPostBody,
          SetupPaymentProviderPaymentProvidersSetupPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupPaymentProviderPaymentProvidersSetupPostSchema,
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SetupPaymentProviderPaymentProvidersSetupPostData,
          OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
          MutationVariables<
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Setup Payment Provider */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupPaymentProviderPaymentProvidersSetupPostSchema,
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostParameters,
            OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Setup Payment Provider
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.paymentProvidersService.setupPaymentProviderPaymentProvidersSetupPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SetupPaymentProviderPaymentProvidersSetupPostBody,
              SetupPaymentProviderPaymentProvidersSetupPostData,
              SetupPaymentProviderPaymentProvidersSetupPostParameters,
              OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupPaymentProviderPaymentProvidersSetupPostSchema,
              SetupPaymentProviderPaymentProvidersSetupPostBody,
              SetupPaymentProviderPaymentProvidersSetupPostData,
              SetupPaymentProviderPaymentProvidersSetupPostParameters,
              OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
              TContext
            >
      ):
        | Mutation<
            SetupPaymentProviderPaymentProvidersSetupPostData,
            SetupPaymentProviderPaymentProvidersSetupPostError,
            MutationVariables<
              SetupPaymentProviderPaymentProvidersSetupPostBody,
              SetupPaymentProviderPaymentProvidersSetupPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SetupPaymentProviderPaymentProvidersSetupPostBody,
              SetupPaymentProviderPaymentProvidersSetupPostData,
              SetupPaymentProviderPaymentProvidersSetupPostParameters,
              OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupPaymentProviderPaymentProvidersSetupPostSchema,
              SetupPaymentProviderPaymentProvidersSetupPostBody,
              SetupPaymentProviderPaymentProvidersSetupPostData,
              SetupPaymentProviderPaymentProvidersSetupPostParameters,
              OperationError<SetupPaymentProviderPaymentProvidersSetupPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SetupPaymentProviderPaymentProvidersSetupPostData,
          SetupPaymentProviderPaymentProvidersSetupPostError,
          MutationVariables<
            SetupPaymentProviderPaymentProvidersSetupPostBody,
            SetupPaymentProviderPaymentProvidersSetupPostParameters
          >,
          TContext
        >
      >;
    };
    schema: SetupPaymentProviderPaymentProvidersSetupPostSchema;
    types: {
      parameters: SetupPaymentProviderPaymentProvidersSetupPostParameters;
      data: SetupPaymentProviderPaymentProvidersSetupPostData;
      error: SetupPaymentProviderPaymentProvidersSetupPostError;
      body: SetupPaymentProviderPaymentProvidersSetupPostBody;
    };
  };
}
/** @summary Get Payment Providers */
export const getPaymentProvidersPaymentProvidersGet = {
  schema: {
    method: 'get',
    url: '/payment_providers',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetPaymentProvidersPaymentProvidersGetSchema;
  [QraftServiceOperationsToken]: PaymentProvidersService['getPaymentProvidersPaymentProvidersGet'];
};
/** @summary Setup Payment Provider */
export const setupPaymentProviderPaymentProvidersSetupPost = {
  schema: {
    method: 'post',
    url: '/payment_providers/setup',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SetupPaymentProviderPaymentProvidersSetupPostSchema;
  [QraftServiceOperationsToken]: PaymentProvidersService['setupPaymentProviderPaymentProvidersSetupPost'];
};
export const paymentProvidersService = {
  getPaymentProvidersPaymentProvidersGet,
  setupPaymentProviderPaymentProvidersSetupPost,
} as const;
type GetPaymentProvidersPaymentProvidersGetSchema = {
  method: 'get';
  url: '/payment_providers';
  security: ['HTTPBearer'];
};
type GetPaymentProvidersPaymentProvidersGetParameters = undefined;
type GetPaymentProvidersPaymentProvidersGetData =
  paths['/payment_providers']['get']['responses']['200']['content']['application/json'];
type GetPaymentProvidersPaymentProvidersGetError = unknown;
type SetupPaymentProviderPaymentProvidersSetupPostSchema = {
  method: 'post';
  url: '/payment_providers/setup';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SetupPaymentProviderPaymentProvidersSetupPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SetupPaymentProviderPaymentProvidersSetupPostData =
  paths['/payment_providers/setup']['post']['responses']['200']['content']['application/json'];
type SetupPaymentProviderPaymentProvidersSetupPostError =
  paths['/payment_providers/setup']['post']['responses']['422']['content']['application/json'];
type SetupPaymentProviderPaymentProvidersSetupPostBody =
  paths['/payment_providers/setup']['post']['requestBody']['content']['application/json'];
